import { SET_SHOPS } from './shops.actions';

const initialState = {
  shops: [],
};

export const shopsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_SHOPS:
      return {
        ...state,
        shops: payload,
      };
    default:
      return state;
  }
};
